const WORK_PT = {
  motorola: {
    cat: "Tech · Global",
    cap: "Power to Empower. 21 países. 18 nacionalidades. Plataforma global.",
    desc: "Criamos <strong>Power to Empower</strong>, a plataforma global da Motorola para empoderar uma nova geração de pensadores, inovadores e agentes de mudança. Uma campanha com 18 nacionalidades em 21 países.",
  },
  "ford-lobo": {
    cat: "Auto · EUA + México",
    cap: "Superprodução sci-fi. As lendas nunca param.",
    desc: "Para a nova Ford F-150 Lobo, criamos uma campanha que rompeu os códigos do mercado mexicano e hispânico nos Estados Unidos. Duas peças cinematográficas de 60 segundos redefiniram o futuro da potência e da aventura.",
  },
  diablo: {
    cat: "Bebidas · Chile",
    cap: "Rebranding total. +1500 touchpoints. +8 pontos de share na categoria.",
    desc: "Sob o conceito <strong>A alma muda, o caráter permanece</strong>, renovamos a identidade de Pisco Diablo com uma narrativa intensa e contemporânea. Uma campanha integral com filmes, conteúdo digital e ativações.",
  },
  "absolut-ba": {
    cat: "Bebidas · Argentina",
    cap: "14ª cidade do mundo com garrafa de edição limitada. Campanha 360°.",
    desc: "Criamos e lançamos de ponta a ponta a primeira garrafa de Absolut dedicada a Buenos Aires. A cidade se tornou a 14ª do mundo com uma edição limitada, em uma campanha 360° com artistas, designers, bartenders e músicos.",
  },
  "absolut-nothing": {
    cat: "Bebidas · Segurança viária",
    cap: "A primeira garrafa de vodka sem vodka. O brief impossível.",
    desc: "Criamos <strong>Absolut Nothing</strong>, a primeira garrafa de vodka sem vodka. As peças foram entregues em bolsas produzidas com airbags reciclados, levando uma mensagem direta sobre álcool e direção.",
  },
  "absolut-grapefruit": {
    cat: "Bebidas · Lançamento",
    cap: "Lançamento de um novo sabor. Grapefruit natural, sem açúcar adicionado.",
    desc: "Acompanhamos o lançamento de Absolut Grapefruit com uma peça vibrante que celebra seu sabor natural, fresco e sem açúcar adicionado.",
  },
  "moto-razr": {
    cat: "Tech · América Latina",
    cap: "Flip & Move. Campanha regional 360°. TV, TikTok, IG e creators.",
    desc: "Criamos uma campanha regional para mostrar todo o potencial dos smartphones dobráveis. Um sistema 360° com TV, TikTok, Instagram, YouTube, influência, marketing direto e mídia exterior.",
  },
  kross: {
    cat: "Cerveja · Chile",
    cap: "Manifesto da cerveja craft pioneira do Chile. Original e autêntica.",
    desc: "Construímos um manifesto que celebra a origem, os prêmios e o caráter inconfundível da Kross, reafirmando seu lugar como referência da cerveja artesanal chilena.",
  },
  "honda-hrv": {
    cat: "Auto · América Latina",
    cap: "Lançamento simultâneo em 8 países. Um conceito que moveu audiências.",
    desc: "Planejamos, criamos, produzimos e implementamos o lançamento da Honda HR-V em oito países ao mesmo tempo, conectando marca e produto por meio de uma narrativa emocional.",
  },
  "honda-hrv-moviliza": {
    cat: "Auto · Lifestyle",
    cap: "Não apenas move. Mobiliza. Uma campanha para uma geração em movimento.",
    desc: "Uma campanha lifestyle para a Honda HR-V que conecta cidade, amigos, cor e liberdade. Um SUV para quem não fica parado.",
  },
  "honda-xr": {
    cat: "Motos · América Latina",
    cap: "Campanha extrema na América Latina. Produção in-house.",
    desc: "Criamos um lançamento extremo para demonstrar todo o potencial da Honda XR300 em toda a América Latina, inaugurando uma nova forma de comunicação para a marca na região.",
  },
  "honda-fit": {
    cat: "Auto · América Latina",
    cap: "A mudança mais radical. Dois dias de aventura na terceira geração.",
    desc: "Reinventamos emoções para apresentar a terceira geração do Honda Fit. Uma narrativa próxima e aspiracional que mostrou todo o potencial do modelo.",
  },
  "honda-accord": {
    cat: "Auto · América Latina",
    cap: "Sistema variável de cilindros. A analogia perfeita.",
    desc: "Transformamos uma tecnologia difícil de explicar em uma ideia simples e poderosa. Com direção de Juan Solanas, criamos um filme compacto para demonstrar o sistema variável de cilindros da Honda.",
  },
  "honda-crv": {
    cat: "Auto · América Latina",
    cap: "Viva a evolução. Uma nova geração de emoções.",
    desc: "Apresentamos a geração mais esportiva, tecnológica e segura da Honda CR-V com uma narrativa emocional, próxima e aspiracional.",
  },
  "honda-despiece": {
    cat: "Auto · Ativação",
    cap: "Um problema transformado na ativação mais bem-sucedida da feira.",
    desc: "Transformamos a desmontagem de uma moto em uma instalação cinematográfica. Cada peça suspensa virou parte de uma experiência imersiva que se tornou o centro do evento.",
  },
  "honda-cb190r": {
    cat: "Motos · América Latina",
    cap: "Naked urbana. Riding noturno cinematográfico. Seja rápido.",
    desc: "Um filme de riding noturno que captura o caráter ágil e potente da Honda CB190R. Uma moto para quem vive a rua de verdade.",
  },
  ridgeline: {
    cat: "Auto · América Latina",
    cap: "Grande em qualquer território. Versatilidade e potência.",
    desc: "Criamos uma campanha potente para demonstrar a versatilidade da Honda Ridgeline e gerar consideração em novas audiências.",
  },
  pecador: {
    cat: "Bebidas · Capel",
    cap: "Marca disruptiva. Skate, rua e atitude para um novo público.",
    desc: "Desenvolvemos para Pecador um sistema de conteúdo fresco e irreverente, quebrando os códigos tradicionais da categoria para falar com uma geração que valoriza autenticidade.",
  },
  hacienda: {
    cat: "Premium · Marca própria",
    cap: "Marca premium criada de ponta a ponta. 16% das vendas totais.",
    desc: "Criamos integralmente uma marca premium: estratégia, posicionamento, produto, embalagem, tom de voz e comunicação. O resultado capturou 16% das vendas totais da companhia.",
  },
  cinzano: {
    cat: "Bebidas · Premium",
    cap: "Masterpiece. Campanha premium para um vermute icônico.",
    desc: "Uma peça de alto impacto visual que reposiciona Cinzano com um tom contemporâneo e aspiracional, conectando tradição a novos rituais de consumo.",
  },
  montefraile: {
    cat: "Vinhos · Virtual Set",
    cap: "Virtual set. A Cordilheira dos Andes como cenário.",
    desc: "Uma campanha sensorial para apresentar um pisco super premium por meio de uma narrativa visual que vai além das palavras.",
  },
  samsung: {
    cat: "Tech · Viral",
    cap: "Mambo viral. Uma conexão que quebrou recordes.",
    desc: "Para Samsung, criamos uma peça conectada ao humor e à cultura pop que alcançou viralização massiva e um alcance orgânico sem precedentes para a marca.",
  },
  quilmes: {
    cat: "Cerveja · Impacto",
    cap: "Um guia para pais e filhos. Consumo responsável com impacto.",
    desc: "Uma campanha de propósito para melhorar a conversa entre pais e adolescentes sobre consumo responsável, tratando um tema sensível com proximidade e honestidade.",
  },
  "bayer-empecid": {
    cat: "Pharma · Social",
    cap: "Uma questão de saúde íntima que decidimos não esconder. #CuídateSinTabú.",
    desc: "Para Empecid Gyno, da Bayer, falamos sem tabu sobre candidíase vaginal. Um manifesto animado, próximo e empático que convida mulheres a se cuidarem sem vergonha.",
  },
  "alto-del-carmen": {
    cat: "Bebidas · Chile",
    cap: "Transformamos a principal marca de pisco. +8 pontos de share.",
    desc: "Redesenhamos estratégia, logo, tom de voz, formatos e mais de 1500 touchpoints de Alto del Carmen. A marca chegou ao primeiro lugar da categoria e ganhou oito pontos de share.",
  },
  acblanca: {
    cat: "Bebidas · Chile",
    cap: "Virtual set. Recriamos a montanha para lançar o novo rótulo.",
    desc: "Usamos tecnologia de virtual set para recriar parte da Cordilheira dos Andes e produzir o conteúdo de lançamento de Alto del Carmen Etiqueta Blanca, rótulo que também desenhamos.",
  },
  cafayate: {
    cat: "Vinhos · Cafayate",
    cap: "Campanha 360° para mostrar vinhos de altitude.",
    desc: "Criamos uma campanha 360° para apresentar a linha completa de vinhos de altitude de Cafayate, sua origem e seus valores em digital, TV, mídia exterior, marketing direto e ponto de venda.",
  },
  sensus: {
    cat: "Bebidas · 100% IA",
    cap: "Filme premium da ideia à publicação em apenas 7 dias.",
    desc: "Criamos um filme premium de ponta a ponta em sete dias. Uma estética em preto e branco com acentos amarelos provou que velocidade de produção e qualidade cinematográfica podem operar juntas.",
  },
  havana: {
    cat: "Bebidas · Tech",
    cap: "NFC Dock. Desconectar para conectar. Tecnologia a serviço do autêntico.",
    desc: "Criamos o primeiro dock NFC que transformava menos tempo no celular em mais momentos com amigos e benefícios de Havana Club.",
  },
  "havana-cubalibre": {
    cat: "Bebidas",
    cap: "Um filme que convida a redescobrir o clássico Cuba Libre.",
    desc: "Elevamos o ritual de rum, cola, gelo e limão em uma peça sensorial que celebra o sabor cubano e o caráter autêntico de Havana Club.",
  },
};

export const getWorkText = (work, lang) => {
  if (lang === "pt") {
    return WORK_PT[work.key] || { cat: work.cat, cap: work.cap, desc: work.desc };
  }
  if (lang === "en") {
    return { cat: work.catEn, cap: work.capEn, desc: work.descEn };
  }
  return { cat: work.cat, cap: work.cap, desc: work.desc };
};

export default WORK_PT;
